import React, { FC } from 'react';

import { ShareClass } from '../../../../hooks/index';
import { EditShareClassStepVariant } from '../modals.types';
import { EditShareClassForm } from './edit-share-class.form';

type ModalProps = {
  companyId: string;
  handleClose: () => void;
  invalidateQuery: () => void;
  isOpenModal: boolean;
  onEditClick: (props: { id: string; step: EditShareClassStepVariant }) => void;
  shareClassId: string;
  step: EditShareClassStepVariant;
};

export const EditShareClassModal: FC<ModalProps> = (props) => {
  const { companyId, shareClassId } = props;

  const { shareClass, isLoading } = ShareClass.useShareClass({
    companyId,
    shareClassId,
  });

  if (!shareClass || isLoading) return <></>;

  return <EditShareClassForm data={shareClass} {...props} />;
};
